import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';
import { NavService } from '../nav.service';

@Directive({
  selector: '[aeNavChange]'
})
export class NavChangeDirective implements OnInit {

  constructor(private navService: NavService, private el: ElementRef, private render: Renderer2) {}

  ngOnInit() {
   this.navService.position$.subscribe(this.changeNavColor.bind(this));
  }

  public changeNavColor(position: string) {
    if (position === 'top') {
      this.render.setStyle(this.el.nativeElement, 'color', 'white')
      this.render.setStyle(this.el.nativeElement, 'z-index', '150000');
    } else {
      
      this.render.setStyle(this.el.nativeElement, 'font-weight', '800');
    }
  }
}
